import ApiClient from '../ApiClient';

class NexceoProjectsAPI extends ApiClient {
  constructor() {
    super('nexceo/projects', { accountScoped: true });
  }
}

export default new NexceoProjectsAPI();
